<template>
  <div id="home" class="main">
    <!-- 头部 -->
    <Header index="1" id="header" @needclear="needclear"></Header>
    <div class="content">
      <!--[if lte IE 9]>
        <p class="browserupgrade">
          You are using an <strong>outdated</strong> browser. Please <a
          href="https://browsehappy.com/">upgrade your browser</a> to improve
          your experience and security.
        </p>
      <![endif]-->

      <!-- Add your site or application content here -->

      <!-- prealoder area start -->
      <!-- <div id="loading">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="first_object"></div>
                <div class="object" id="second_object"></div>
                <div class="object" id="third_object"></div>
                </div>
            </div>      
        </div> -->
      <!-- prealoder area end -->

      <div class="body-overlay transition-3"></div>
      <!-- extra info area end -->

      <main>
        <!-- slider area end -->

        <!-- banner area start -->

        <!-- banner area end -->

        <!-- Cart Area Strat-->
        <section class="cart-area pt-100 pb-100">
          <div class="container">
            <h3> </h3>
             <h3 class="hidden-xs-only " style="margin-top: 50px">Billing Details 清单</h3>
            <h3 class="hidden-sm-and-up" style="margin-top: 50px">Billing Details</h3>
            <h3 class="hidden-sm-and-up">清单</h3>
            <div class="row">
              <div class="col-12">
                <form action="#">
                  <div class="table-content table-responsive">
                    <table class="table">
                      <thead>
                        <tr>
                          <th class="product-thumbnail">Images</th>
                          <th class="cart-product-name">Product</th>
                          <th class="product-price">Unit Price</th>
                          <th class="product-quantity">Quantity</th>
                          <th class="product-subtotal">Total</th>
                          <th class="product-remove">Remove</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in nowcartlists" :key="index">
                          <td class="product-thumbnail">
                            <a @click="viewnews(item.goods_id)" class="point"
                              ><img :src="allurl + item.thumb" alt=""
                            /></a>
                          </td>
                          <td class="product-name font-16">
                            <a >{{ item.title }}</a>
                           <p class="font-16">{{ item.ex_title }}</p>
                           
                          </td>
                          <td class="product-price">
                            <span class="amount">${{ item.money }}</span>
                          </td>
                          <td class="product-quantity">
                            <div class="cart-plus-minus">
                              <el-input-number
                                :step-strictly="true"
                                v-model="item.num"
                                @blur="blur(index, item.num)"
                                @change="change(index, item.num)"
                                :min="1"
                                :max="item.numbers"
                              ></el-input-number>
                              <p class="font-16" style="margin-bottom:0">库存 Stock：{{item.numbers}} </p>
                              <p class="font-16" style="color:red;margin-bottom:0">{{item.numbers &lt; item.num ||  item.num &gt; item.numbers?'该产品库存不足':''}} </p>
                            </div>
                          </td>
                          <td class="product-subtotal">
                            <span class="amount"
                              >${{ (item.money * item.num).toFixed(2)}}</span
                            >
                          </td>
                          <td class="product-remove">
                            <a @click="remove(index)"
                              ><i class="fa fa-times"></i
                            ></a>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td>Total</td>
                          <td></td>
                          <td></td>
                          <td>{{ allnum }}</td>
                          <td>${{ allmoney }}</td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <!-- <div class="row">
                    <div class="col-12">
                      <div class="coupon-all">
                        <div class="coupon">
                          <input
                            id="coupon_code"
                            class="input-text"
                            name="coupon_code"
                            value=""
                            placeholder="Coupon code"
                            type="text"
                          />
                          <button
                            class="os-btn os-btn-black"
                            name="apply_coupon"
                            type="submit"
                          >
                            Apply coupon
                          </button>
                        </div>
                        <div class="coupon2">
                          <button
                            class="os-btn os-btn-black"
                            name="update_cart"
                            type="submit"
                          >
                            Update cart
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-5 ml-auto">
                      <div class="cart-page-total">
                        <h2>Cart totals</h2>
                        <ul class="mb-20">
                          <li>Subtotal <span>$250.00</span></li>
                          <li>Total <span>$250.00</span></li>
                        </ul>
                        <a class="os-btn" href="checkout.html"
                          >Proceed to checkout</a
                        >
                      </div>
                    </div>
                  </div> -->
                </form>
              </div>
            </div>

            <h3 class="hidden-xs-only " style="margin-top: 50px">Ordering information 订购信息</h3>
            <h3 class="hidden-sm-and-up" style="margin-top: 50px">Ordering information</h3>
            <h3 class="hidden-sm-and-up">订购信息</h3>
            <div class="formarea">
              <el-form
                label-position="left"
                ref="form"
                size="medium "
                :rules="rules"
                :model="form"
                class="elformcss"
              >
               <el-form-item label="Phone" prop="phone">
                  <el-input v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="Your name" prop="name">
                  <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="Email" prop="email">
                  <el-input v-model="form.email"></el-input>
                </el-form-item> 
               
                <el-form-item required label="Address" v-show="form.brake == 2">
                  <el-input v-model="form.address"></el-input>
                </el-form-item>
                <el-form-item label="Pickup add" v-show="form.brake == 1">
                  <div>{{ concact }}</div>
                </el-form-item>

                 <el-form-item
                  required
                  label-width="110px"
                  class="hidden-xs-up"
                  label="Chose date"
                  v-show="form.brake == 1"
                > 
                  <el-date-picker
                    style="margin-bottom:10px;"
                    format="yyyy-MM-dd"
                    :picker-options="setDisabled"
                    value-format="yyyy-MM-dd"
                    v-model="form.times[0]"
                    type="date"
                    placeholder="Chose start date">
                  </el-date-picker>
                  <el-date-picker
                    style="margin-bottom:10px;"
                    format="yyyy-MM-dd"
                    :picker-options="setDisabled"
                      value-format="yyyy-MM-dd"
                    v-model="form.times[1]"
                    type="date"
                    placeholder="Chose end date">
                  </el-date-picker>
                  
                </el-form-item>  

                <el-form-item
                  required
                   class="hidden-xs-only"
                  label="Chose date"
                  v-show="form.brake == 1"
                > 
                 
                  <el-date-picker
                    @change="timechange()"
                    v-model="form.times"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    :picker-options="setDisabled"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                  >
                  </el-date-picker>
                 
                </el-form-item>

                <el-form-item label="Delivery method">
                  <!-- <el-switch v-model="form.delivery"></el-switch> -->
                  <el-radio-group v-model="form.brake">
                    <el-radio label="1"
                      >Collect in Store 超市自提</el-radio
                    >
                    <!-- <el-radio label="2">Express delivery 快递配送</el-radio> -->
                  </el-radio-group>
                </el-form-item>
                
                <el-form-item label="Payment method">
                  <div class="display480">
                    <p>Make your payment directly into our bank account. Please use
                    your Order ID as the payment reference. Your order won’t be
                    shipped until the funds have cleared in our account.</p>
                    
                  </div>
                </el-form-item>

                <!-- <el-form-item label="活动形式">
                  <el-input type="textarea" v-model="form.desc"></el-input>
                </el-form-item> -->
                <el-form-item>
                  <el-button type="primary" @click="onSubmit('form')"
                    >Place order</el-button
                  >
                  <!-- <el-button>取消</el-button> -->
                </el-form-item>
              </el-form>
               <!-- <van-datetime-picker
                      v-model="currentDate"
                      type="datetime"
                      title="选择完整时间"
                      :min-date="minDate"
                      :max-date="maxDate"
                    /> -->
            </div>
          </div>
        </section>
        <!-- Cart Area End-->
        <el-dialog
          title="确认订单"
          :visible.sync="centerDialogVisible"
          width="90%"
          show-close
          center
        >
          <div class="your-order mb-30">
            <h3>Your order</h3>
            <div class="your-order-table table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="product-name">Product</th>
                    <th class="product-total">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="cart_item"
                    v-for="(item, index) in nowcartlist"
                    :key="index"
                  >
                    <td class="product-name ">
                       {{ item.ex_title }} {{ item.title }}
                      <strong class="product-quantity">
                        × {{ item.num }}</strong
                      >
                    </td>
                    <td class="product-total">
                      <span class="amount">${{item.money * item.num}}</span>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="cart-subtotal">
                    <th>Cart Subtotal</th>
                    <td>
                      <span class="amount">${{ allmoney }}</span>
                    </td>
                  </tr>

                  <tr class="cart-subtotal " style="margin-top:20px;border-top:3px solid #ccc">
                    <th>Name</th>
                    <td>
                      <span class="amount">{{ form.name}}</span>
                    </td>
                  </tr>
                  <tr class="cart-subtotal " >
                    <th>Email</th>
                    <td>
                      <span class="amount">{{ form.email}}</span>
                    </td>
                  </tr>
                  <tr class="cart-subtotal " >
                    <th>Phone</th>
                    <td>
                      <span class="amount">{{ form.phone}}</span>
                    </td>
                  </tr>
                  <tr class="cart-subtotal " >
                    <th>Delivery method</th>
                    <td>
                      <span class="amount"> <i class="el-icon-circle-check"></i> {{ form.brake==1?'Collect in Store 超市自提':'快递配送'}}</span>
                    </td>
                  </tr>
                  <tr class="cart-subtotal " >
                    <th>{{form.brake==1?'Pickup add':'配送地址'}}</th>
                    <td>
                      <span class="amount">{{form.brake==1?concact:form.address}}</span>
                    </td>
                  </tr> 
                  
                </tfoot>
                
              </table>
              
            </div>

            <!-- <div class="payment-method">
                                    <div class="accordion" id="accordionExample">
                                        <div class="card">
                                            <div class="card-header" id="headingOne">
                                                <h5 class="mb-0">
                                                    <button class="btn-link" type="button" data-toggle="collapse"
                                                        data-target="#collapseOne" aria-expanded="true"
                                                        aria-controls="collapseOne">
                                                        Direct Bank Transfer
                                                    </button>
                                                </h5>
                                            </div>

                                            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    Make your payment directly into our bank account. Please use your Order ID
                                                    as the payment
                                                    reference. Your order won’t be
                                                    shipped until the funds have cleared in our account.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingTwo">
                                                <h5 class="mb-0">
                                                    <button class="btn-link collapsed" type="button" data-toggle="collapse"
                                                        data-target="#collapseTwo" aria-expanded="false"
                                                        aria-controls="collapseTwo">
                                                        Cheque Payment
                                                    </button>
                                                </h5>
                                            </div>
                                            <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    Please send your cheque to Store Name, Store Street, Store Town, Store
                                                    State / County, Store
                                                    Postcode.
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card">
                                            <div class="card-header" id="headingThree">
                                                <h5 class="mb-0">
                                                    <button class="btn-link collapsed" type="button" data-toggle="collapse"
                                                        data-target="#collapseThree" aria-expanded="false"
                                                        aria-controls="collapseThree">
                                                        PayPal
                                                    </button>
                                                </h5>
                                            </div>
                                            <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                                data-parent="#accordionExample">
                                                <div class="card-body">
                                                    Pay via PayPal; you can pay with your credit card if you don’t have a
                                                    PayPal account.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="order-button-payment mt-20">
                                        <button type="submit" class="os-btn os-btn-black">Place order</button>
                                    </div>
                                </div> -->
          </div>
          <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="centerDialogVisible = false">取 消</el-button> -->
            <el-button type="primary" @click="fanenter()" :loading="orderloading"
              >submit</el-button
            >
          </span>
        </el-dialog>
      </main>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";
import { cartadd, getconcact, seach_num } from "@/api/index/index";
export default {
  components: { Header, Footer },
  name: "home",
  data() {
    return {
      currentIndex: "",
      teacherIndex: "",
      orderloading:false,//订单转圈loading
      ishove: true,
      menuctive: 10,
      minDate: new Date(),
      maxDate: new Date(),
      currentDate: new Date(),
      activeBtn: 2,
      allnum: 0,
      allmoney: 0,
      fanlmoney: 0,
      lock: false,
      clickIndex: 0,
      lanmuhe: "",
      concact: "Local store",
      getnumid:[],
      shopid:'',
      windowWidth:'',
      centerDialogVisible: false,
      //   <span>New product &nbsp;|&nbsp; </span>
      //                                         <span>Discount |&nbsp; </span>
      //                                         <span>Rxpenditures </span>
      menuchoose: ["New product", "Discount", "Expenditures"],
      form: {
        name: "",
        email: "",
        address: "",
        times: [],
        time1:'',
        time2:'',
        type: [],
        is_verify: 0,
        brake: "1",
        phone: "",
      },
      formName:'',
      rules: {
        name: [
          {  message: "请输入姓名", trigger: "blur" , required: true,},
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        phone: [
          {
            required: true,
            message: "电话不能为空",
            trigger: "blur",
          },
          {
            pattern: /^(0\d{2,3}-?\d{7,8})|((((1[0-9]{2}))+\d{8}))$|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/,
            message: "请输入正确的电话号码",
            trigger: "blur",
          },
        ],
        email: [
          {
           
            message: "电子信箱不能为空",
            trigger: "blur",
          },
          {
            validator: function (rule, value, callback) {
              if(value==''){
                callback();
              }else  if (
                /^[a-zA-Z0-9]+([-_.][A-Za-z0-9]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/i.test(
                  value
                ) == false
              ) {
                callback(new Error("邮箱格式错误"));
                
              }
              
              else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        times: [
          {
            required: true,
            message: "请选择自提时间",
            trigger: "blur",
          },
        ],
      },
      setDisabled: {
        disabledDate(time) {
         
          // return time.getTime() > Date.now();  // 可选历史天、可选当前天、不可选未来天
          // return time.getTime() > Date.now() - 8.64e7;  // 可选历史天、不可选当前天、不可选未来天
          // return time.getTime() < Date.now() - 8.64e7; // 不可选历史天、可选当前天、可选未来天111
          // return time.getTime() < Date.now(); // 不可选历史天、不可选当前天、可选未来天
          let now = (new Date()).getTime();
          let sevenAfter = 14*24*3600*1000;
          let res = now + sevenAfter;
          
          
          return time.getTime() < Date.now() - 8.64e7|| time.getTime()>res
        },
      },
      nowcartlist: [],//购物车清单
       nowcartlists: [],//购物车清单
      numlist:[],//库存清单
      value: "",
      leftIcon: require("../../assets/left.png"),
      rightIcon: require("../../assets/right-active.png"),
      orderlock:false,
    };
  },
  mounted() {
    // let video = document.getElementsByClassName('video')
    // video.play()
    // 滚动条的获取
    var that = this;

   
    that.windowWidth = document.documentElement.clientWidth; //获取屏幕宽度
    //console.log(that.windowWidth)
    
    that.getcartlist();
  },
  created() {
    //   //console.log('滚动高度', window.pageYOffset)
  },
  filters: {
  numFilter (value) {
    // 截取当前数据到小数点后两位
    let realVal = parseFloat(value).toFixed(2)
    // return realVal
  }
},
  methods: {
    needclear(){//传值到子页面header
      
    },
    getallnum() {
      var allsnum = 0;
      var allsmoney = 0;
      var uuid=''
      var lock = false;
     
    
      if (this.nowcartlist) {
        this.nowcartlist.forEach((item) => {
          // this.nowcartlist.numbers=0
          
          allsmoney += item.num * item.money;
          // uuid=item.uuid+','
          allsnum += item.num;
          lock = true;
    
        });
        
          
        if (lock) {
          this.allnum = allsnum;
          this.allmoney = allsmoney.toFixed(2);
        }
      }
       seach_num({id:this.getnumid}).then((res)=>{
        this.numlist=res
        if(this.numlist!=''){
        
        this.nowcartlist.forEach((item,index) => {
          // item.numbers=0
          // this.nowcartlist.numbers=0
           //console.log(this.numlist,'forEach1')
          this.numlist.forEach((items) => {
            //console.log(item,items,'forEach2')
            if(item.goods_id==items.id){
              //console.log('111111')
              item.numbers= parseInt(items.numbers) 
            }
            // this.nowcartlist.numbers=items.numbers
          }) 
           
        });
        this.nowcartlists=this.nowcartlist
        //console.log(this.nowcartlist,'1123111');
      }
        //console.log( this.numlist)
      })
      
    },
    timechange(res) {
      //console.log(1111);
    },
    viewnews(id) {
      // this.$router.push({ name: "newsview" });
      //console.log(id);
      this.$router.push({ name: "productview", query: { id } });
    },
    change(index, num) {
      this.getallnum();
    },
    blur(index, num) {
      //console.log(this.nowcartlist[index]);
      if (num == "" || num == undefined) {
        //  //console.log(this.nowcartlist[index])
        this.nowcartlist[index].num = 1;
        this.getallnum();
      }
    },
    remove(index) {
      // this.nowcartlist[index].num=1

      this.$confirm("是否从购物车删除此商品", "删除", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.nowcartlist.splice(index, 1);
          sessionStorage.setItem("cart", JSON.stringify(this.nowcartlist));
          this.getallnum();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          if(this.nowcartlist==''){
            this.allnum=0
            this.allmoney=0
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //获取购物车信息
    getcartlist() {

      if(sessionStorage.getItem("shopid") != "" && sessionStorage.getItem("shopid") != null){
        this.shopid = sessionStorage.getItem("shopid");
      }
      
      console.log(this.shopid);
      this.nowcartlist = JSON.parse(sessionStorage.getItem("cart"));
      getconcact().then((res) => {
        // this.concact = res.content.title;
      });
      if (sessionStorage.getItem("concact") != "" && sessionStorage.getItem("concact") != null) {
        //console.log(sessionStorage.getItem("concact"),'缓存有地址')
        this.concact = sessionStorage.getItem("concact");
      }
      if(this.nowcartlist){
        this.nowcartlist.forEach(item => {
          this.getnumid.push(item.goods_id)
        });
      }
      
      
      // this.nowcartlist.forEach(item => {
      //   item.allmoney=item.num*item.num
      //   //console.log(item,'item')
      // });
      // allmoney
      //console.log(this.nowcart);
      
        this.getallnum();
      
      
    },
    addchoose(code) {
      this.menuctive = code;
    },
    changestyle(index) {
      this.currentIndex = index;
    },
    fanenter(){
      if(this.centerDialogVisible){
        this.orderlock=true
        this.onSubmit(this.formName)
      }
    },
    onSubmit(formName) {
      //console.log(this.form)
      var uuid=''
      this.nowcartlist.forEach((item) => {
        uuid+=item.uuid+','
        // uuid=item.uuid+','
       
        
      }); 
      //console.log(uuid)
      // return
      if(!this.nowcartlist||this.nowcartlist==''){
        this.msgError("购物车里还没有商品");
        return
      }
      this.formName=formName
      this.getallnum();
      var addform = [];
      //console.log(this.form);
      this.form["money"] = this.allmoney;
      var lock = true;
      this.form["uuid"] =uuid;
      this.form["shops_id"] =this.shopid;
      
      this.form["goods"] = this.nowcartlist;
      
      //console.log(this.form);
      var addform = this.form;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.brake == 1) {
            if (!this.form.times) {
              //console.log();
              this.msgError("请填写自提时间");
              lock = false;
            }else if(!this.form.times[0]){
              this.msgError("请填写自提开始时间");
              lock = false;
            }else if(!this.form.times[1]){
              this.msgError("请填写自提结束时间");
              lock = false;
            }
          } else {
            if (!this.form.address) {
              this.msgError("请填写配送地址");
              lock = false;
            }
          }
          // alert("submit!");
          if (lock) {
            this.centerDialogVisible=true//打开弹窗开关
            
            if(this.orderlock){
              this.orderloading=true  
             
              //console.log('点击了提交按钮')
              cartadd(addform).then((response) => {
              if (response.code == 200) {
                this.orderloading=false  
                // this.centerDialogVisible = false;z
                this.msgSuccess("订单提交成功");
                this.nowcartlist=[],
                this.nowcartlists=[],
                
                sessionStorage.setItem('cart',JSON.stringify(this.nowcartlist))
                
                 sessionStorage.setItem('cartnum',0)
                 setTimeout(() => {
                   this.centerDialogVisible=false
                   this.$router.push({ name: "home" });
                 }, 1000);
                 
                // this.open = false;
                // this.getList();
                //  this.$refs.upload.clearFiles();
              } else {
                this.msgError(response.message);
                //  this.$refs.upload.clearFiles();
              }
            });  
            }else{
              //console.log('点击预览页面')
              // this.fanenter()
            }
            
            
            
          }
        } else {
          //console.log("error submit!!");
          return false;
        }
      });
      // Array.from(this.form)

      // (this.form).then((res) => {

      // })
      
    },
    originstyle() {
      this.currentIndex = "";
    },
    clicktap(index) {
      this.clickIndex = index;
    },
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();
        //console.log(val);
        this.activeBtn = 2;
        this.rightIcon = require("../../assets/right-active.png");
        this.leftIcon = require("../../assets/left.png");
      } else {
        this.$refs.cardShow.prev();
        //console.log(val);
        this.activeBtn = 1;
        this.leftIcon = require("../../assets/left-active.png");
        this.rightIcon = require("../../assets/right.png");
      }
    },
    changehandle(currentIndex, originIndex) {
      //console.log(currentIndex, originIndex);
    },
    // 移入事件
    delHandleMouseEnter(index) {
      this.teacherIndex = index;
    },
    // 移出
    delHandleMouseleave() {
      this.teacherIndex = "";
    },
  },
};
</script>

<style scoped lang='less'>
.formarea {
  margin: 40px 0;
  padding: 40px 10px;
  border: 1px solid #eaedff;
}
h3 {
  text-align: left;
  margin: 20px;
}
.banner__area {
  z-index: 100;
}
.owl-carousel {
  display: flex;
  flex-wrap: wrap;
}
.product__area .product__thumb a {
  display: block;
}
.col-xl-20 {
  width: 20%;
}
// .col-lg-20{width:20%}
.col-md-20 {
  width: 20%;
}
.col-xs-6 {
  width: 50%;
}
.display480 p{text-align: left;}
.hidden-xs-up{display: none;}
@media (max-width: 768px) {
  .hidden-xs-up{display: block;}
  .display480{display: inline-block;}
}


@media (min-width: 768px) {
  .col-md-20 {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
  }
  .elformcss {
    width: 80%;
  }
  .formarea {
    padding: 40px;
  }
}
@media (min-width: 990px) {
  .col-md-20 {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
  }
  .col-lg-20 {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
  }
  .col-xl-20 {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
  }
}
@media (max-width: 480px) {
  /deep/.el-dialog--center .el-dialog__body{padding:10px 10px 20px}
  .el-dialog{    width: 80%!important;} 
  th,td{font-size: 12px!important;}
  td span{font-size: 12px!important;}
}



.el-button--primary{color: #ffffff;
    background-color: #323232;
    border-color: #323232;}
.product-quantity input {
  height: 40px;
}
.font-16{font-size: 16px!important;color:#212529!important}
.is-right{display:none}
//  .col-xl-20
// .sale__item a{display: block;}
// .banner__item{padding:10px;width:100%;background:#ccc;text-align: left;}
// .link-btn{border:2px solid #bc8246;border-radius: 10px;padding:1px 2px;text-transform: none;}
// .show-text span{cursor: pointer;}
// .show-text b{padding:1px 3px;}
/deep/.el-input-number .el-input__inner{padding-left: 30px;
    padding-right: 30px;}

   /deep/ .el-input-number span{
     width: 34px
   }

  /deep/ .el-popper{left:10%}
// .show-text .active b{background:#bc8246;border-radius: 10px;color:#fff}
</style>
<style scoped>
  
</style>



// WEBPACK FOOTER //
// src/views/cart/cart.vue